import { WelcomeContainer } from './styles';
import FormSelectSearchable from '@components/Form/FormSelectSearchable';
import { useCallback, useEffect, useState } from 'react';
import { useInternationalAccessStore } from '@src/store/admin/international-access';
import SortedTable from './components/DefaultSortedTable';
import { ComponentLoading } from '@components/Loading';
import EditIcon from '@mui/icons-material/Edit';
import { Link, useNavigate } from 'react-router-dom';
import { PAYMENT_TILES, COUNTRIES_LIST } from '@helper/constants/international';
import Breadcrumb from '@components/Breadcrumb';
import Container from '@components/Container';

export const tableHeaders= [
  {
    key: 'label',
    name: 'Payment Tile'
  },
  {
    key: 'SK',
    name: 'Payment Tile Path',
  },
  {
    key: 'countries',
    name: 'Allowed Countries',
  }
];

const InternationalAccess = () => {
  const store = useInternationalAccessStore((s) => s);
  const getPaymentTilesOptions = useInternationalAccessStore((s) => s.getPaymentTilesOptions);
  const [paymentTilesCountries, setPaymentTilesCountries] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const paymentTilesCountries = await getPaymentTilesOptions();
      const result = PAYMENT_TILES.map(tile => {
        const match = paymentTilesCountries.find(t => t.SK === tile.SK);
        const matchCountries = match
          ? match.countries
              .map(code => {
                const country = COUNTRIES_LIST.find(c => c.value === code);
                return country ? country.text : code;
              })
              .join(', ')
          : [];
        // Only display SK with "/" prefix, do not modify the actual value
        const displaySK = tile.SK.startsWith('/') ? tile.SK : `/${tile.SK}`;
        return {
          ...tile,
          displaySK,
          countries: matchCountries
        };
      });

      setPaymentTilesCountries(result);
    };
  
    fetchData();
  }, []);

  const navigate = useNavigate();
  const handleEdit = useCallback(
    (item) => {
      navigate(`/admin/international-access/edit/${encodeURIComponent(item.SK)}`);
    },
    [navigate],
  );

  const itemActions = [
    {
      name: 'Edit',
      description: 'Edit countries',
      icon: EditIcon,
      handler: handleEdit,
    },
  ];

  return (
    <WelcomeContainer>
      <Container>
        <Breadcrumb />
      </Container>
      <section className="main-content">
        {store.isLoading && (<div className="row">
            <div className="tw-flex tw-justify-center tw-items-center tw-w-full tw-h-40">
              <ComponentLoading />
            </div>
        </div>)}
        {!store.isLoading && <div className="row">
            <SortedTable
            title="Payment Tiles List"
            data={paymentTilesCountries}
            headers={[
              { key: 'label', name: 'Payment Tile' },
              { key: 'displaySK', name: 'Payment Tile Path' }, // use displaySK here
              { key: 'countries', name: 'Allowed Countries' }
            ]}
            isLoading={false}
            placeholder={'Sorry, we could not find any available records.'}
            itemActions={itemActions}
            cellAlignMiddle
            />
        </div>}
      </section>
    </WelcomeContainer>
  );
};

export default InternationalAccess;
